import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import wp from './modules/wp';
import wc from './modules/wc';
import auth from './modules/auth';

// eslint-disable-next-line no-undef
const { state } = __VUE_WORDPRESS__;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentPage: null,
    currentSingle: null,
    lang: state.i18n ? state.i18n.default : 'default',
    menu: false,
    transition: true,
    overlay: false,
    snackbar: {
      content: null,
      active: false,
    },
    search: false,
    goBack: false,
  },
  mutations,
  getters,
  actions,
  modules: {
    wp,
    wc,
    auth,
  },
});
